const treeColsMultiLines = () => {
  const cps = document.querySelectorAll('.cp-tree-3-cols-multi-lines');
  if (!cps.length) return;

  let cpsAmount = cps.length;
  cps.forEach(cp => {
    cp.style.zIndex = cpsAmount + 1;
    cpsAmount -= 1;
    const cardWrappers = cp.querySelectorAll('.item-card');
    let zIndexCounter = cardWrappers.length;
    cardWrappers.forEach(wrapper => {
      wrapper.style.zIndex = zIndexCounter;
      zIndexCounter -= 1;
    })
  })
};

export default treeColsMultiLines;